<script>
    import Request from './Request';

    export default {
        extends: Request,
        name: 'All',
        props: {
            action: {},
            query: {
                type: Object,
                default: () => ({})
            },
        },
        data() {
            return {
                localData: []
            };
        },
        methods: {
            async request() {
                //console.log('request all')
                try {
                    this.loading = true;

                    const model = await this.getModel();
                    this.localData = await model.all({
                        query: this.query,
                        ...this.config
                    });
                    this.$emit('update:data', this.localData);
                    this.$emit('updated', this.localData);
                } catch (error) {
                    console.log(error);
                    this.error = error;
                } finally {
                    this.loading = false;
                }
            },
        },
        watch:{
            query:{
                handler(a, b){
                    if(JSON.stringify(a) != JSON.stringify(b)) {
                        if(this.immediate){
                            this.request();
                        }
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>